import React from 'react';
import dynamic from 'next/dynamic';

const DynamicAgentPage = dynamic(() => import('../Agent/Agent'), {ssr: false});

export default function UserPage(props) {
  const {node} = props;

  return (
      <div className={`user-page`}>
        {node?.roles?.length > 0 && node.roles.includes('agent') &&
        <DynamicAgentPage node={node} eaton_sold={props.eaton_sold}
                          eaton_list={props.eaton_list}
                          agent_list={props.agent_list}/>
        }
      </div>
  );
}
